import { render } from "./PromotionalSMSDialog.vue?vue&type=template&id=1c249f72&ts=true"
import script from "./PromotionalSMSDialog.vue?vue&type=script&lang=ts"
export * from "./PromotionalSMSDialog.vue?vue&type=script&lang=ts"

import "./PromotionalSMSDialog.vue?vue&type=style&index=0&id=1c249f72&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__